import { render, staticRenderFns } from "./MyLoansDetails.vue?vue&type=template&id=4aed6d0e"
import script from "./MyLoansDetails.vue?vue&type=script&lang=js"
export * from "./MyLoansDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports